<section class="grid gap-0">
  <!-- Card heading (INS finder only — authored via the Craft category's finderHeading) -->
  @if (finderHeading) {
    <h2 class="finder-heading">{{ finderHeading }}</h2>
  }
  <!-- Select Element -->
  <vision-select [label]="stateDropdownLabel" selectId="state" class="mb-3" [isLoadingState]="isLoadingState" [isLoadingPlaceholder]="'Loading your state'"
    [placeholder]="'Select a State'" [extendClassStyles]="'custom-class'" [data]="states"
    (changeEvent)="handleStateChange($event)" [defaultSelectedOption]="stateFromGeolocation">
  </vision-select>
  <!-- Course Type Element (INS only — rendered from the start when the data carries a courseType, disabled until a state is picked) -->
  @if (showCourseType) {
    <vision-select label="Course Type" selectId="course-type" class="mb-3" [disabled]="courseTypeDisabled" [placeholder]="'Select a course type'"
      [extendClassStyles]="'custom-class'" [data]="courseTypes"
      (changeEvent)="handleCourseTypeChange($event)" [defaultSelectedOption]="selectedCourseType">
    </vision-select>
  }
  <!-- Select Element (hidden for a two-step finder category, or when the finder selection resolves to a single destination, e.g. Continuing Education) -->
  @if (!hideProductSelect) {
    <vision-select [label]="productDropdownLabel" selectId="product" class="mb-4" [disabled]="selectedProductsDisabled" [placeholder]="'Select a Product'"
      [extendClassStyles]="'custom-class'" [data]="this.selectedProducts"
      (changeEvent)="handleProductChange($event)" [defaultSelectedOption]="productDefault">
    </vision-select>
  }
  <!-- Link Button -->
  <vision-button defaultStyle="primary" [data]="finalCtaButtonData" [disabled]="ctaDisabled"></vision-button>
</section>
